import React, { useRef, useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Row, Col, Drawer, Input, Form, Space, Typography, Carousel } from 'antd';
import style from './Announcements.module.scss';
import { ResponsiveModal } from '../../features/responsive/ResponsiveModal.js';
import dayjs from 'dayjs';
import moment from 'moment';
import { LeftOutlined, BellFilled } from '@ant-design/icons';
import { useMediaQuery } from 'react-responsive'

const AnnouncementViewModal = ({ announcementDetails, isModalOpen, onClose, preview }) => {
  const { i18n, t } = useTranslation();
  const [announcementData, setAnnouncementData] = useState([]);
  const [dismissedData, setDismissedData] = useState({});
  const isMobile =useMediaQuery({ maxWidth: 767 })

  useEffect(() => {
    if (!isModalOpen) return;

    setAnnouncementData(announcementDetails.map(i => {
      const messageObj = i?.message ? JSON.parse(i.message) : {};

      return {
        title: i?.title,
        id: i?.id,
        intro: messageObj?.intro,
        bullets: messageObj?.bullets || [],
        footer: messageObj?.footer,
        startDate: i?.startAt ? dayjs(i.startAt) : null,
        endDate: i?.endAt ? dayjs(i.endAt) : null
      };
    }));

  }, [isModalOpen, announcementDetails]);

  return (
    <ResponsiveModal
      onClose={() => onClose(dismissedData)}
      title={<div style={{ color: "darkgreen" }}><BellFilled style={{ marginRight: 8 }} /> {t("Announcement.ViewTitle", {date : moment().format('D MMM YYYY')})}</div>}
      isModalOpen={isModalOpen}
      width={"35%"}
      withPadding={false}
      style={{ minWidth: 350 }}
      footer={null}
    >
      <Carousel arrows infinite={false} dots={false}>
        {announcementData.filter(i => !dismissedData[i?.id]).map(i => {
          return (<Space direction="vertical" className={`${style.fullWidthCarousel}`}>
            <Row>
              <Col xs={{ span: 24 }}>
                <Typography.Title level={3}>{i?.title}</Typography.Title>
              </Col>
            </Row>
            <Row>
              <Col xs={{ span: 24 }}>
                <Typography.Paragraph>{i?.intro}</Typography.Paragraph>
              </Col>
              {(i?.bullets || []).length > 0 && (
                <Col xs={{ span: 24 }}>
                  <ul style={{ margin: 0 }}>
                    {i.bullets.map((bullet, index) => (
                      <li key={index}>{bullet}</li>
                    ))}
                  </ul>
                </Col>
              )}
            </Row>
            <Row style={{ borderTop: '1px solid #f0f0f0', marginTop: 16, paddingTop: 16 }}>
              <Col xs={{ span: 24 }}>
                <Typography.Paragraph type="secondary">{i?.footer}</Typography.Paragraph>
              </Col>
            </Row>
            {!preview &&
              <Row style={{ marginTop: 16, paddingTop: 16 }}>
                <Col xs={{ span: 24 }}>
                  <Button block={isMobile}
                    type="primary"
                    onClick={() => {
                      setDismissedData(prev => ({ ...prev, [i?.id]: true }));
                      if (Object.keys(dismissedData).length + 1 === announcementData.length) {
                        onClose({ ...dismissedData, [i?.id]: true });
                      }
                    }}
                  >
                    {t("Common.GotIt")}
                  </Button>
                </Col>
              </Row>
            }
          </Space>);
        })}
      </Carousel>
    </ResponsiveModal>
  )
}

export default AnnouncementViewModal;